module.exports = __webpack_public_path__ + "img/bollebilletter.0f3c823f.jpg";